(function(angular) {
    'use strict';

    angular.module('um.filters').config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('main.filters', {
                'abstract': true,
                url: 'filters/',
                template: '<ui-view/>',
                breadcrumb: 'FILTERS'
            })
            .state('main.filters.overview', {
                url: 'overview',
                templateUrl: 'modules/filters/filters.overview.html',
                controller: 'filters.overview.controller',
                controllerAs: 'filters',
                breadcrumb: 'OVERVIEW'
            })
            .state('main.filters.create', {
                url: 'create',
                templateUrl: 'modules/filters/filter.html',
                controller: 'filters.controller',
                controllerAs: 'filter',
                breadcrumb: 'CREATE'
            })
            .state('main.filters.edit', {
                url: 'edit/:filterId',
                templateUrl: 'modules/filters/filter.html',
                controller: 'filters.controller',
                controllerAs: 'filter',
                breadcrumb: 'EDIT'
            })
            .state('main.filters.userlist', {
                url: 'userdetails/:filterId',
                templateUrl: 'modules/filters/filter.userlist.html',
                controller: 'filter.userlist.controller',
                controllerAs: 'userlist',
                breadcrumb: 'FILTERS_USER_DETAILS'
            });
    }]);
})(window.angular);
